import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { FullSizeColumn } from '../../../Components/FlexBox';
import Dialog from '../../../Components/Dialog';
import Select from '../../../Components/Inputs/Select';
import { Typography } from '@mui/material';

const CampaignSelectionDialog = function CampaignSelectionDialog({
  open,
  onClose,
  activeCampaigns = [],
  onSubmit,
  campaignId,
}) {
  const intl = useIntl();
  const [value, setValue] = useState(campaignId || '');

  return (
    <Dialog
      id="campaign-selection-dialog"
      open={open}
      onClose={onClose}
      hideCloseIcon={!campaignId}
      title="CAMPAIGN_SELECTION"
      width="sm"
      onSubmit={() => onSubmit(value)}
      disableSubmit={!value}
      fullWidth
      dividers
      disableEscapeKeyDown
      disableBackdropClick
    >
      <FullSizeColumn padding="16px" minHeight="100px" gap="16px">
        <Typography
          variant="body1"
          sx={{
            fontSize: '1.5rem',
          }}
        >
          {intl.messages.CUSTOMER_HAS_MULTIPLE_ACTIVE_CAMPAIGNS}
        </Typography>
        <Select
          name="campaign"
          label="CAMPAIGN_SELECTION"
          options={activeCampaigns?.map(({ id, description }) => ({
            value: id,
            label: description,
          }))}
          value={value}
          onChange={setValue}
          required
        />
      </FullSizeColumn>
    </Dialog>
  );
};

export default CampaignSelectionDialog;
